/**
 * Compare deux tableaux de clés (chaînes de caractères) et retourne un objet
 * indiquant quelles clés ont été ajoutées, supprimées ou sont restées inchangées.
 *
 * Utile pour détecter les différences entre un état initial et un état mis à jour,
 * par exemple dans un contexte de gestion de formulaires dynamiques ou de synchronisation de données.
 *
 * @param initialKeys - Le tableau de clés initiales
 * @param newKeys - Le tableau de nouvelles clés à comparer
 * @returns Un objet contenant trois tableaux : added, unchanged, removed
 */

type DiffResult = {
	added: string[];
	unchanged: string[];
	removed: string[];
};

export default function diffKeys(initialKeys: string[], newKeys: string[]): DiffResult {
	const initialSet = new Set(initialKeys);
	const newSet = new Set(newKeys);

	const added = newKeys.filter(key => !initialSet.has(key));
	const unchanged = newKeys.filter(key => initialSet.has(key));
	const removed = initialKeys.filter(key => !newSet.has(key));

	return { added, unchanged, removed };
}
